import { DOMNode } from 'html-react-parser';
import CustomImage from '../components/ora/Study/Exam/components/CustomImage';
import { resolvePrimaryImageAttribution } from './imageAttribution';

/**
 * Renders an authored `<img data-image-caption>` as the shared CustomImage,
 * which carries the caption, the credit/licence line and the annotated variant.
 *
 * Images inside vignette copy are licensed material, so wherever that copy is
 * rendered, the attribution has to come with it — this handler is what both the
 * QBank explanation panel and the chat question block use to guarantee that.
 * Returns undefined for anything else so callers can chain their own handling.
 */
export const replaceVignetteImage = (domNode: DOMNode) => {
  if (
    domNode.type !== 'tag' ||
    domNode.name !== 'img' ||
    !domNode.attribs ||
    !domNode.attribs['data-image-caption']
  ) {
    return undefined;
  }

  const {
    src,
    'data-image-caption': caption,
    'data-image-credit': credit,
    'data-image-copyright-license': copyrightLicense,
    'data-image-copyright-license-url': copyrightLicenseUrl,
    'data-image-copyright-credit-url': copyrightCreditUrl,
    'data-image-src-annotated': annotatedSrc,
  } = domNode.attribs;

  const attribution = resolvePrimaryImageAttribution({
    credit,
    copyright: {
      license: copyrightLicense,
      licenseUrl: copyrightLicenseUrl,
      creditUrl: copyrightCreditUrl,
    },
  });

  return (
    <CustomImage
      src={src}
      caption={caption}
      credit={attribution}
      annotatedSrc={annotatedSrc}
    />
  );
};
